import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initMonitoring } from "./lib/monitoring";
import { installTranslationGuard } from "./lib/translation-guard";
import { initAttribution } from "./lib/attribution";

// Keep in-browser page translation (Google Translate etc.) from crashing
// React's DOM reconciliation. Must run before the first render.
installTranslationGuard();

// Error monitoring is inert unless REACT_APP_SENTRY_DSN is set (see
// docs/env-variables.md) and sets no cookies, so it starts here.
// Google Analytics (which DOES set cookies) is intentionally NOT started here —
// it is gated behind cookie consent and initialized from <CookieConsent /> only
// after the visitor accepts.
initMonitoring();

// Capture where this visit came from (UTM params, else referrer) before any
// client-side navigation rewrites the URL and loses the tags. The capture
// itself stores no identifier and is not consent-gated; the anonymous visit
// PING it may fire is (see src/lib/attribution.ts for the reasoning).
initAttribution();

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);

// To measure performance, pass a reporting function to reportWebVitals.
// Example: reportWebVitals(console.log) or send to an analytics endpoint.
// See: https://bit.ly/CRA-vitals
reportWebVitals();
